import './CtaRegister.scss'

import isWithinInterval from 'date-fns/isWithinInterval'
import React from 'react'
import {LinkType, WysiwygType} from '../../../types'
import {dateFromServerDate} from '../../../util/dates'
import {style} from '../../../util/style'
import {Theme} from '../../../views/Theme'

const styles = style('ctaregister')

export type CtaRegisterType = {
	className?: string
	title?: string
	text?: WysiwygType
	button?: LinkType
	date_start: string
	date_end: string
}

export const CtaRegister: React.FC<CtaRegisterType> = ({
	className,
	title,
	text,
	button,
	date_start,
	date_end
}) => {
	if (!title && !text && !button) return null

	let todayIsInInterval = false
	if (date_start && date_end) {
		const todayDate = new Date()
		const startServerDate = dateFromServerDate(date_start)
		const endServerDate = dateFromServerDate(date_end)

		todayIsInInterval = isWithinInterval(todayDate, {
			start: startServerDate,
			end: endServerDate
		})
	}

	if (!todayIsInInterval) return null

	return (
		<div className={styles().with(className)}>
			{title && (
				<Theme.H3 className={styles('title')} mod="green">
					{title}
				</Theme.H3>
			)}
			{text && (
				<div className={styles('text')}>
					<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
				</div>
			)}
			{button?.url && (
				<div className={styles('button')}>
					<Theme.Button to={button.url} withIcon="arrow">
						{button.description || button.title}
					</Theme.Button>
				</div>
			)}
		</div>
	)
}
